import { queryOptions } from '@tanstack/react-query';
import { WHAT_PEOPLE_SAY_QUERY_KEYS } from './keys';
import type { GetProductReviewInsightRequest } from './types';
import { whatPeopleSayAPIClient } from '../whatPeopleSayAPIClient';

export const WHAT_PEOPLE_SAY_QUERIES = {
  getWhatPeopleSay: (params: GetProductReviewInsightRequest) =>
    queryOptions({
      queryKey: WHAT_PEOPLE_SAY_QUERY_KEYS.getWhatPeopleSay(params),
      queryFn: () => whatPeopleSayAPIClient.getWhatPeopleSay(params),
    }),
};
